/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiTransSet.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-trans-set";

export class AutogenModelEdiTransSet<RowType extends ModelRow> extends Endpoint<RowType, RowEdiTransSetFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiTransSet extends ModelRow<RowEdiTransSetFields> {
	constructor(values?: Partial<RowEdiTransSetFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiTransSetFields {
	company_id: string;
	create_date: Date;
	direction: string;
	func_grp_ctl_no: number;
	func_grp_sequence: number;
	func_receiver_id: string;
	func_sender_id: string;
	functional_grp_dt: Date;
	functional_grp_id: string;
	id: string;
	inter_receiver_id: string;
	inter_sender_id: string;
	interchange_ctl_no: number;
	interchange_date: Date;
	interchange_id: string;
	order_id: string;
	sequence: number;
	set_control_no: string;
	shipment_id: string;
	transaction_set_id: string;
	transaction_type: string;
	version: string;
	was_successful: string;
}

